import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createStaticVNode as _createStaticVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/logoText.svg'


const _hoisted_1 = { id: "nav" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("img", {
  alt: "luki.solutions logo",
  src: _imports_0
}, null, -1)
const _hoisted_3 = { id: "links" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode("home")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("projects")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("about")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("contact")
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { id: "menu" }, [
  /*#__PURE__*/_createElementVNode("div", {
    id: "hamburger-line",
    class: "up"
  }),
  /*#__PURE__*/_createElementVNode("div", {
    id: "hamburger-line",
    class: "down"
  })
], -1)
const _hoisted_9 = { id: "footer" }
const _hoisted_10 = /*#__PURE__*/_createStaticVNode("<div id=\"logos\"><a target=\"_blank\" href=\"https://instagram.com/luki.solutions\"><svg width=\"37\" height=\"37\" viewBox=\"0 0 37 37\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><g clip-path=\"url(#clip0_101_425)\"><path d=\"M18.7678 4.16694C23.5772 4.16694 24.1467 4.18804 26.0381 4.27241C27.7959 4.34976 28.7452 4.64507 29.378 4.89116C30.2147 5.2146 30.8194 5.60835 31.4452 6.23413C32.078 6.86694 32.4647 7.4646 32.7881 8.30132C33.0342 8.93413 33.3295 9.89038 33.4069 11.6412C33.4913 13.5396 33.5124 14.1091 33.5124 18.9115C33.5124 23.7209 33.4913 24.2904 33.4069 26.1818C33.3295 27.9396 33.0342 28.8888 32.7881 29.5216C32.4647 30.3584 32.0709 30.963 31.4452 31.5888C30.8124 32.2216 30.2147 32.6084 29.378 32.9318C28.7452 33.1779 27.7889 33.4732 26.0381 33.5505C24.1397 33.6349 23.5702 33.656 18.7678 33.656C13.9584 33.656 13.3889 33.6349 11.4975 33.5505C9.7397 33.4732 8.79048 33.1779 8.15767 32.9318C7.32095 32.6084 6.71626 32.2146 6.09048 31.5888C5.45767 30.956 5.07095 30.3584 4.74751 29.5216C4.50142 28.8888 4.2061 27.9326 4.12876 26.1818C4.04438 24.2834 4.02329 23.7138 4.02329 18.9115C4.02329 14.1021 4.04438 13.5326 4.12876 11.6412C4.2061 9.88335 4.50142 8.93413 4.74751 8.30132C5.07095 7.4646 5.4647 6.85991 6.09048 6.23413C6.72329 5.60132 7.32095 5.2146 8.15767 4.89116C8.79048 4.64507 9.74673 4.34976 11.4975 4.27241C13.3889 4.18804 13.9584 4.16694 18.7678 4.16694ZM18.7678 0.925537C13.8811 0.925537 13.2694 0.946631 11.3499 1.03101C9.43735 1.11538 8.12251 1.42476 6.98345 1.86772C5.79517 2.33179 4.7897 2.94351 3.79126 3.94897C2.78579 4.94741 2.17407 5.95288 1.71001 7.13413C1.26704 8.28023 0.957666 9.58804 0.873291 11.5005C0.788916 13.4271 0.767822 14.0388 0.767822 18.9255C0.767822 23.8123 0.788916 24.424 0.873291 26.3435C0.957666 28.256 1.26704 29.5709 1.71001 30.7099C2.17407 31.8982 2.78579 32.9037 3.79126 33.9021C4.7897 34.9005 5.79517 35.5193 6.97642 35.9763C8.12251 36.4193 9.43032 36.7287 11.3428 36.813C13.2624 36.8974 13.8741 36.9185 18.7608 36.9185C23.6475 36.9185 24.2592 36.8974 26.1788 36.813C28.0913 36.7287 29.4061 36.4193 30.5452 35.9763C31.7264 35.5193 32.7319 34.9005 33.7303 33.9021C34.7288 32.9037 35.3475 31.8982 35.8045 30.7169C36.2475 29.5709 36.5569 28.263 36.6413 26.3505C36.7256 24.431 36.7467 23.8193 36.7467 18.9326C36.7467 14.0459 36.7256 13.4341 36.6413 11.5146C36.5569 9.6021 36.2475 8.28726 35.8045 7.14819C35.3616 5.95288 34.7499 4.94741 33.7444 3.94897C32.746 2.95054 31.7405 2.33179 30.5592 1.87476C29.4131 1.43179 28.1053 1.12241 26.1928 1.03804C24.2663 0.946631 23.6545 0.925537 18.7678 0.925537Z\" fill=\"white\"></path><path d=\"M18.7678 9.67944C13.6631 9.67944 9.52173 13.8208 9.52173 18.9255C9.52173 24.0302 13.6631 28.1716 18.7678 28.1716C23.8725 28.1716 28.0139 24.0302 28.0139 18.9255C28.0139 13.8208 23.8725 9.67944 18.7678 9.67944ZM18.7678 24.9232C15.4561 24.9232 12.7702 22.2373 12.7702 18.9255C12.7702 15.6138 15.4561 12.9279 18.7678 12.9279C22.0795 12.9279 24.7655 15.6138 24.7655 18.9255C24.7655 22.2373 22.0795 24.9232 18.7678 24.9232Z\" fill=\"white\"></path><path d=\"M30.5381 9.31375C30.5381 10.5091 29.5678 11.4723 28.3795 11.4723C27.1842 11.4723 26.2209 10.502 26.2209 9.31375C26.2209 8.11843 27.1913 7.15515 28.3795 7.15515C29.5678 7.15515 30.5381 8.12547 30.5381 9.31375Z\" fill=\"white\"></path></g><defs><clipPath id=\"clip0_101_425\"><rect width=\"36\" height=\"36\" fill=\"white\" transform=\"translate(0.767822 0.925537)\"></rect></clipPath></defs></svg></a><a target=\"_blank\" href=\"https://www.youtube.com/c/XtremeTechYT\"><svg width=\"42\" height=\"42\" viewBox=\"0 0 42 42\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M41.5816 12.6C41.5816 12.6 41.1715 9.70432 39.9082 8.43284C38.3086 6.7594 36.5203 6.7512 35.7 6.65276C29.8266 6.2262 21.0082 6.2262 21.0082 6.2262H20.9918C20.9918 6.2262 12.1734 6.2262 6.3 6.65276C5.47969 6.7512 3.69141 6.7594 2.0918 8.43284C0.828516 9.70432 0.426562 12.6 0.426562 12.6C0.426562 12.6 0 16.0043 0 19.4004V22.5832C0 25.9793 0.418359 29.3836 0.418359 29.3836C0.418359 29.3836 0.828515 32.2793 2.08359 33.5508C3.6832 35.2242 5.7832 35.1668 6.71836 35.3473C10.0816 35.6672 21 35.7656 21 35.7656C21 35.7656 29.8266 35.7492 35.7 35.3309C36.5203 35.2324 38.3086 35.2242 39.9082 33.5508C41.1715 32.2793 41.5816 29.3836 41.5816 29.3836C41.5816 29.3836 42 25.9875 42 22.5832V19.4004C42 16.0043 41.5816 12.6 41.5816 12.6ZM16.6605 26.4469V14.6426L28.0055 20.5653L16.6605 26.4469Z\" fill=\"white\"></path></svg></a><a target=\"_blank\" href=\"https://de.linkedin.com/in/lukas-runge-73b43321b\"><svg width=\"37\" height=\"37\" viewBox=\"0 0 37 37\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><g clip-path=\"url(#clip0_101_426)\"><path d=\"M33.5673 0.925537H2.88999C1.42046 0.925537 0.232178 2.08569 0.232178 3.52007V34.324C0.232178 35.7583 1.42046 36.9255 2.88999 36.9255H33.5673C35.0369 36.9255 36.2322 35.7584 36.2322 34.331V3.52007C36.2322 2.08569 35.0369 0.925537 33.5673 0.925537ZM10.9126 31.6029H5.5689V14.4185H10.9126V31.6029ZM8.24077 12.0771C6.52515 12.0771 5.13999 10.6919 5.13999 8.98335C5.13999 7.27476 6.52515 5.8896 8.24077 5.8896C9.94937 5.8896 11.3345 7.27476 11.3345 8.98335C11.3345 10.6849 9.94937 12.0771 8.24077 12.0771ZM30.9095 31.6029H25.5728V23.2498C25.5728 21.2599 25.5376 18.6935 22.7955 18.6935C20.0181 18.6935 19.5962 20.8662 19.5962 23.1091V31.6029H14.2666V14.4185H19.3853V16.7669H19.4556C20.1658 15.4169 21.9095 13.9896 24.5041 13.9896C29.9111 13.9896 30.9095 17.5474 30.9095 22.174V31.6029V31.6029Z\" fill=\"white\"></path></g><defs><clipPath id=\"clip0_101_426\"><rect width=\"36\" height=\"36\" fill=\"white\" transform=\"translate(0.232178 0.925537)\"></rect></clipPath></defs></svg></a></div>", 1)
const _hoisted_11 = { id: "text" }
const _hoisted_12 = /*#__PURE__*/_createTextVNode("imprint")

import { ref } from "vue";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const menu = ref(false);

function resetMenu() {
  var box = document.getElementById("checkbox") as unknown as any;
  box.checked = false;
}

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _withDirectives(_createElementVNode("input", {
        class: "checkbox",
        type: "checkbox",
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((menu).value = $event)),
        name: "",
        id: "checkbox"
      }, null, 512), [
        [_vModelCheckbox, menu.value]
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_router_link, {
          onClick: resetMenu,
          to: "/"
        }, {
          default: _withCtx(() => [
            _hoisted_4
          ]),
          _: 1
        }),
        _createVNode(_component_router_link, {
          onClick: resetMenu,
          to: "/projects"
        }, {
          default: _withCtx(() => [
            _hoisted_5
          ]),
          _: 1
        }),
        _createVNode(_component_router_link, {
          onClick: resetMenu,
          to: "/about"
        }, {
          default: _withCtx(() => [
            _hoisted_6
          ]),
          _: 1
        }),
        _createVNode(_component_router_link, {
          onClick: resetMenu,
          to: "/contact"
        }, {
          default: _withCtx(() => [
            _hoisted_7
          ]),
          _: 1
        })
      ]),
      _hoisted_8
    ]),
    _createVNode(_component_router_view),
    _createElementVNode("div", _hoisted_9, [
      _hoisted_10,
      _createElementVNode("div", _hoisted_11, [
        _createVNode(_component_router_link, { to: "/imprint" }, {
          default: _withCtx(() => [
            _hoisted_12
          ]),
          _: 1
        }),
        _createTextVNode(" © luki.solutions " + _toDisplayString(new Date().getFullYear()), 1)
      ])
    ])
  ], 64))
}
}

})